import styles from "styled-components"
import ReactPlayer from "react-player";
import "@fontsource/lexend";

export const WorkContainer = styles.div`
    width: 100%;
    height: auto;
    background-color: #282c34;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

export const WorkVideoTitle = styles.div`  
    margin-top: 50px;
    color: #f3f3f3;
    font-size: 80px;
    text-align: center;
    font-family: "Bebas Neue";
    
   @media screen and (max-width: 768px) { 
        font-size: 42px;
        display: none;
    }
    
   @media screen and (max-width: 480px) { 
        font-size: 36px;
        display: none;
    }
`;

export const WorkSection = styles.section`
  width: 100%;
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 0 8px;
`;

export const VideoFrame = styles.div`
  position: relative;
  width: min(1024px, 92vw);
  aspect-ratio: 16 / 9;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.35);
  margin: 0 auto 28px;

  @media (max-width: 480px) {
    border-radius: 12px;
    margin-bottom: 22px;
  }
`;


export const WorkVideoTitleMobile = styles.div`  
    color: #f3f3f3;
    font-size: 60px;
    text-align: center;
    font-family: "Bebas Neue";
    
   @media screen and (min-width: 768px) { 
        display: none;
    }
`;

export const WorkVideoSubtitle = styles.div`  
    margin-top: 15px;
    margin-bottom: 50px;
    
    color: #f3f3f3;
    font-size: 20px;
    text-align: center;
    font-family: "Lexend";
    
   @media screen and (max-width: 768px) { 
        font-size: 18px;
        max-width: 80%;
    }
    
   @media screen and (max-width: 480px) { 
        font-size: 16px;
        max-width: 80%;
    }
`;

export const WorkCTASection = styles.div`
  margin: 60px 0;
  display: flex;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap; /* stack on small screens */
`;

export const WorkButton = styles.button`
  appearance: none;
  border: 0;
  cursor: pointer;

  font-family: "Lexend";
  font-weight: 700;
  font-size: 16px;

  padding: 14px 22px;
  border-radius: 10px;

  background: #012D9C;      /* brand primary */
  color: #FFE0DF;           /* brand secondary */
  box-shadow: 0 4px 14px rgba(1,45,156,0.35);

  transition: transform 0.08s ease, opacity 0.2s ease;

  &:hover { opacity: 0.95; }
  &:active { transform: translateY(1px) scale(0.99); }
`;

export const WorkVideo = styles(ReactPlayer)`  
    position: absolute !important;
    top: 0; left: 0;
    width: 100% !important;
    height: 100% !important;
`;
